import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Index from './pages/Index';
import Projects from './pages/Projects';
import NotFound from './pages/NotFound';
import './App.css';

function App() {
  useEffect(() => {
    document.title = 'Portifólio - Flávio Bianchetti';
  }, []);
  return (
    <section>
      <Routes>
        <Route exact path="/" element={ <Index /> } />
        <Route exact path="/projects" element={ <Projects /> } />
        <Route path="*" element={ <NotFound /> } />
      </Routes>
    </section>
  );
}

export default App;
